import { ChangeDetectionStrategy, Component, DestroyRef, ElementRef, inject, OnInit, output, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { HttpService } from 'src/app/services/http.service';
import { ControlPoint } from '../../bo/controlPoint';
import { ProprieteAffichee } from '../../bo/proprieteAffichee';
import { Vibration } from '../../bo/vibration';
import { VibrationsChart } from '../../bo/vibrationsForChart/vibrationsChart';
import { FonctionsService } from '../../services/fonctions-partagees.service';
import { UtilisateurService } from '../../services/utilisateur.service';
import { Chart } from 'src/app/utils/chart-config';
import { UntypedFormGroup } from '@angular/forms';
import { HttpClient, HttpErrorResponse, HttpEvent, HttpEventType } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { VibrationsSave } from '../../bo/vibrationsForChart/vibrationsSave';
import { VibrationsChartChannel } from '../../bo/vibrationsForChart/vibrationsChartChannel';
import { NgxFileDropEntry, FileSystemFileEntry, FileSystemDirectoryEntry } from 'ngx-file-drop';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-donnees-vibration-modale',
  templateUrl: './donnees-vibration-modale.component.html',
  styleUrls: ['./donnees-vibration-modale.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class DonneesVibrationModaleComponent implements OnInit {
  modaleFermee = output<boolean>();
  isNew = signal(false);
  isNewValue = false;
  vibrationsNewModelSelected = signal<VibrationsChart>(undefined);
  erreurApi = signal(false);

  vibrationsChart = signal<VibrationsChart[]>([]);
  tabDonneesVibrationNewModel: VibrationsChart[] = [];

  vibrationsChartRemote = signal<VibrationsChart[]>([]);
  vibrationsChartLocal = signal<VibrationsChart[]>([]);

  vibrationsSave: VibrationsSave[] = [];

  controlPoints: ControlPoint[];
  activeControlPoint = signal<ControlPoint>(undefined);
  activeControlPointValue: ControlPoint;
  activeControlPointFilter = signal<ControlPoint>(null);

  tirId: number;
  siteId: number;
  vibrationNewModel: VibrationsChart;
  vibrationView: any = new VibrationsChart();
  vibrationModif: Vibration;
  vibrationOldModel: Vibration;
  estModif = signal(false);
  estModifValue = false;

  dragAnddrop = signal(false);
  indexSelected = signal<number>(undefined);
  proprietesAffichees: ProprieteAffichee[];
  minMax = signal<number[]>([]);
  files: File[] = [];
  arrowSort = signal(Array(5));
  activeSort = signal<number>(undefined);
  isRemoteOrLocal = signal(false);
  fourChannelCheck = signal(false);
  isMoreThanFour = signal(false);
  barValue = signal('0%');
  fileTempSended = signal('');

  private readonly destroyRef = inject(DestroyRef);

  constructor(public bsModalRef: BsModalRef, private readonly httpClient: HttpClient, private readonly http: HttpService, protected readonly fonctionsService: FonctionsService,
    protected readonly utilService: UtilisateurService, private readonly el: ElementRef, private readonly bsModalService: BsModalService) { }

  ngOnInit() {
    this.isNew.set(!!this.isNewValue);
    this.estModif.set(!!this.estModifValue);
    if (this.activeControlPointValue) {
      this.activeControlPoint.set(this.activeControlPointValue);
    }

    if (this.estModif()) {
      if (this.isNew()) {
        this.vibrationView = this.vibrationNewModel;
      } else {
        this.vibrationView = this.vibrationOldModel;
      }
    } else {
      this.vibrationView = new VibrationsChart();
    }

    this.proprietesAffichees = new VibrationsChart().getProprietesAffichees();
    if (null !== this.vibrationNewModel && undefined !== this.vibrationNewModel) {
      this.vibrationsChart.set([this.vibrationNewModel]);
      this.vibrationsNewModelSelected.set(this.vibrationNewModel);
      this.setCheck4Channel(this.vibrationNewModel);
      this.indexSelected.set(0);
      setTimeout(() => {
        this.drawingVibrations();
      }, 0);
    } else if (!this.estModif()) {
      this.vibrationModif = new Vibration();
      this.vibrationNewModel = new VibrationsChart();
      this.chargerVibrations();
    }
  }

  private chargerVibrations() {
    this.fonctionsService.loading_screen(true);
    this.http.get<VibrationsChart[]>('VibrationsMongo/' + this.utilService.currentSite().siteId + '/GetAllBySiteIdAndDateTime/' + this.utilService.currentTir.tirId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(vibrations => {
        this.fonctionsService.loading_screen(false);
        this.vibrationsChartRemote.set(vibrations);
        this.vibrationsChart.set(vibrations);
      }, (error: HttpErrorResponse) => {
        if (error.status === 401 || error.status === 403) {
          console.log(error.error);
        }
        this.showToastAndCloseLoadingsScreen(false);
      });
  }

  public dropped(f: NgxFileDropEntry[]) {
    this.fonctionsService.loading_screen(true);
    this.dragAnddrop.set(true);
    this.files = [];
    
    const droppedEntries = Array.isArray(f) ? f : [];
     for (const droppedFile of droppedEntries) {
      // Is it a file?
      if (droppedFile.fileEntry && droppedFile.fileEntry.isFile && this.isFileAllowed(droppedFile.fileEntry.name)) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file( (file: File) => {
          this.files.push(file)
        });
      } else if (droppedFile.fileEntry) {
        const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
      }
    }

    setTimeout(() => {
      if(this.files.length > 0){
        this.managerFile(); 
      }else{
        this.fonctionsService.loading_screen(false);
      }
    }, 10 * droppedEntries.length);
  }

  ///send files to backend
  private managerFile() {
    this.vibrationsChartLocal.set([]);
    this.fourChannelCheck.set(true);
    let formData = new FormData();
    for (let i = 0; i < this.files.length; i++) {
      formData.append('files', this.files[i], this.files[i].name);
    }
   this.uploadFiles(formData).subscribe((event: HttpEvent<VibrationsChart[]>) => {
    switch (event.type) {
      case HttpEventType.Sent:
        break;
      case HttpEventType.ResponseHeader:
        this.isRemoteOrLocal.set(true);
        break;
      case HttpEventType.UploadProgress:
        this.barValue.set(Math.round(event.loaded / event.total * 100).toString() + '%');
        break;
      case HttpEventType.Response:
        const vib: VibrationsChart[] = event.body;
        if (vib != null) {
          this.chartListUpdate(vib);
        }
        this.fonctionsService.loading_screen(false);
        this.fileTempSended.set('filesSended');
        setTimeout(() => {
          this.barValue.set('0%');
        }, 500);
    }
   }, (error) => {
      this.fonctionsService.loading_screen(false);
      setTimeout(() => {
        this.barValue.set('0%');
      }, 500);
   });
  }

   private chartListUpdate(vib: VibrationsChart[]) {
     this.vibrationsChartLocal.update(arr => [...arr, ...vib]);
     this.vibrationsChart.set(this.vibrationsChartLocal());
     this.vibrationsNewModelSelected.set(vib[0]);
     if (vib[0].header.controlPointId != undefined && vib[0].header.controlPointId > 0) {
       this.activeControlPoint.set(this.controlPoints.find(c => c.controlPointId === vib[0].header.controlPointId));
     } else {
       this.activeControlPoint.set(undefined);
     }
     this.indexSelected.set(0);
     this.setCheck4Channel(vib[0]);
     setTimeout(() => {
       this.drawingVibrations();
     }, 0);
   }

   private onRemove() {
     this.files = [];
     this.vibrationsNewModelSelected.set(new VibrationsChart());
     this.vibrationsChart.update(arr => arr.slice(1));
     this.dragAnddrop.set(false);
  }

  private uploadFiles(data: FormData): Observable<HttpEvent<VibrationsChart[]>> {
    return this.httpClient.post<VibrationsChart[]>(environment.exploreURL + '/VibrationsMongo/' + this.utilService.currentSite().siteId + '/ReadDragAndDropVibrationsFile', data, {
      reportProgress: true,
      observe: 'events'
    });
  }

  private addVibrationsToTir() {
    this.fonctionsService.loading_screen(true);
    //old model    (if no vibration from list is selected)
    if (this.vibrationsNewModelSelected() === undefined) {
        const vibOldModel: Vibration = new Vibration();

        vibOldModel.siteId          = this.utilService.currentSite().siteId;
        vibOldModel.tirId           = this.utilService.currentTir.tirId;
        vibOldModel.picVibration    = this.vibrationView.picVibration;
        vibOldModel.surpression     = this.vibrationView.surpression;
        vibOldModel.distance        = parseInt(this.vibrationView.distance);
        vibOldModel.controlPointId  = this.activeControlPoint().controlPointId;
        vibOldModel.numeroPtControl = this.activeControlPoint().numeroPoint;

        if (!this.estModif()) {
          this.http.post('Vibrations/' + this.utilService.currentSite().siteId + '/AddVibrationOldModel', vibOldModel).subscribe((result) => {
            this.bsModalService.setDismissReason('vibAdded');
            this.bsModalRef.hide();
            this.showToastAndCloseLoadingsScreen(true);
          }, (error: HttpErrorResponse) => {
            if (error.status === 401 || error.status === 403) {
              console.log(error.error);
            }
            this.bsModalRef.hide();
            this.showToastAndCloseLoadingsScreen(false);
          });
        } else {
          vibOldModel.id = this.vibrationView.id;
          this.http.put('Vibrations/' + this.utilService.currentSite().siteId + '/UpdateVibrationOldModel', vibOldModel).subscribe((result) => {
            this.bsModalService.setDismissReason('vibAdded');
            this.bsModalRef.hide();
            this.showToastAndCloseLoadingsScreen(true);
          }, (error: HttpErrorResponse) => {
            if (error.status === 401 || error.status === 403) {
              console.log(error.error);
            }
            this.bsModalRef.hide();
            this.showToastAndCloseLoadingsScreen(false);
          });
        }
    }
    //new model
    else {
      const oldVibSave = new VibrationsSave();
      const newVibSave = new VibrationsSave();
      const selected = this.vibrationsNewModelSelected();
      const activeCP = this.activeControlPoint();

      const existingVib = this.tabDonneesVibrationNewModel.find(v => v.header.controlPointId === activeCP.controlPointId);
      if (existingVib != undefined && existingVib != null) {
        oldVibSave.id             = existingVib.id;
        oldVibSave.siteId         = existingVib.header.siteId;
        oldVibSave.tirId          = 0;
        oldVibSave.controlPointId = 0;
      }
      newVibSave.id              = selected.id;
      newVibSave.fileName        = selected.header.fileName;
      newVibSave.tirId           = this.utilService.currentTir.tirId;
      newVibSave.siteId          = this.utilService.currentSite().siteId;
      newVibSave.controlPointId  = activeCP.controlPointId;
      newVibSave.numeroPtControl = activeCP.numeroPoint;
      newVibSave.distance        = parseInt(this.vibrationView.distance);
      newVibSave.picVibration    = this.vibrationView.picVibration;
      newVibSave.surpression     = this.vibrationView.surpression;

      if (this.estModif() && this.isNew())
        newVibSave.idVibrationMaria = this.vibrationView.idVibrationMaria;

      if (this.estModif() && !this.isNew())
        newVibSave.idVibrationMaria = this.vibrationView.id;

      const oldAndNewVibration = [oldVibSave, newVibSave];

      if (this.dragAnddrop()) {
        this.http.post('VibrationsMongo/' + this.utilService.currentSite().siteId + '/SaveVibrationsFromDragAndDrop', oldAndNewVibration).subscribe((result) => {
          this.bsModalService.setDismissReason('vibAdded');
          this.bsModalRef.hide();
          this.showToastAndCloseLoadingsScreen(true);
        }, (error: HttpErrorResponse) => {
          if (error.status === 401 || error.status === 403) {
            console.log(error.error);
          }
          this.bsModalRef.hide();
          this.showToastAndCloseLoadingsScreen(false);
        }, () => {
          this.dragAnddrop.set(false);
        });
      } else {
        this.http.put('VibrationsMongo/' + this.utilService.currentSite().siteId + '/UpdateVibrations', oldAndNewVibration).subscribe((result) => {
          this.bsModalService.setDismissReason('vibAdded');
          this.bsModalRef.hide();
          this.showToastAndCloseLoadingsScreen(true);
        }, (error: HttpErrorResponse) => {
          if (error.status === 401 || error.status === 403) {
            console.log(error.error);
          }
          this.bsModalRef.hide();
          this.showToastAndCloseLoadingsScreen(false);
        });
      }
    }
  }

  protected onSubmit(f: UntypedFormGroup) {
    if (f.valid !== undefined && f.valid) {
      this.addVibrationsToTir();
    }
  }

  private validationDonnees(): boolean {
    if (this.vibrationModif.controlPoint !== null && this.vibrationModif !== undefined
      && this.vibrationModif.picVibration > 0 && this.vibrationModif.picVibration !== undefined) {
      return true;
    }
    else return false;
  }

  protected selectVibration(vib: VibrationsChart, index: number) {
    this.setCheck4Channel(vib);
    if (this.indexSelected() === index) {
      this.vibrationsNewModelSelected.set(undefined);
      this.indexSelected.set(undefined);
      return;
    }

    if (vib.header.controlPointId > 0) {
      this.activeControlPoint.set(this.controlPoints.filter(c => c.controlPointId === vib.header.controlPointId)[0]);
    } else {
      this.activeControlPoint.set(undefined);
    }

    this.vibrationsNewModelSelected.set(vib);
    this.indexSelected.set(index);
    setTimeout(() => {
      this.drawingVibrations();
    }, 0);
  }

  private drawingVibrations() {
    if (this.vibrationsNewModelSelected() === undefined) return;
    this.minMax.set(this.findMinMax(this.vibrationsNewModelSelected()));
    this.vibrationsNewModelSelected().channels.forEach((value, index, array) => {
      if (!this.checkChannelData(value)) {
        this.drawingChannel(index, this.vibrationsNewModelSelected());
      }
    });
  }

private setCheck4Channel(vib: VibrationsChart) {
  if (vib.channels[3] != null || vib.channels[3] != undefined) {
    this.isMoreThanFour.set(vib.channels.length > 4);
    this.fourChannelCheck.set(!this.checkChannelData(vib.channels[3]));
  } else {
    this.fourChannelCheck.set(false);
  }
}

private drawingChannel(index: number, vibrations: VibrationsChart) {
  let canvas = <HTMLCanvasElement>this.el.nativeElement.querySelector('#canvas-' + index);
  let ctx = canvas.getContext('2d')
  // create array with values for the x axis
  let array_for_label = [];
  vibrations.channels[index].value.forEach((value, index) => {
    array_for_label[index] = index;
  });
  let chart = new Chart(ctx, {
    type: 'line',
    data: {
      labels: array_for_label,
      datasets: [{
        label: 'Channel #' + (index + 1),
        data: vibrations.channels[index].value,
        fill: false,
        tension: 0.1,
        borderWidth: 1,
        borderColor: 'rgb(153,0,77)',
        backgroundColor: 'white'
      }],
    },
    options: {
      elements: {
        point: {
          radius: 0
        },
      },
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false,
          position: 'bottom' as const,
          labels: {
            boxWidth: 0
          },
        }
      },
      scales: {
        x: {
          grid: {
            tickLength: 3
          },
          ticks: {
            maxTicksLimit: vibrations.channels.length,
            callback: function (value, index, ticks) {
              return Math.round(index / 2048) + 's';
            },
            padding: 0
          },
          display: false,
        },
        y: {
          min: (index < vibrations.channels.length - 1) ? this.minMax()[0] : this.minMax()[2],
          max: (index < vibrations.channels.length - 1) ? this.minMax()[1] : this.minMax()[3],
          suggestedMin: 0,
          beginAtZero: true,
          ticks: {
            stepSize: 0.5,
          },
        }
      }
    }
  });
}

  private findMinMax(vibration: VibrationsChart): number[] {
    let minMax = [0, 0, 0, 0];
    vibration.channels.forEach((value, index, array) => {
      if (index < vibration.channels.length - 1) {
        if (value.minValue < minMax[0]) minMax[0] = value.minValue;
        if (value.maxValue > minMax[1]) minMax[1] = value.maxValue;
      } else {
        // this is last channel
        minMax[2] = value.minValue;
        minMax[3] = value.maxValue;
      }
    })
    return minMax;
  }

  protected sortByPropriete(propriete: ProprieteAffichee, i: number) {
    this.indexSelected.set(undefined);
    this.vibrationsNewModelSelected.set(undefined);
    this.activeSort.set(i);
    this.arrowSort.update(arr => {
      const copy = [...arr].map(() => false);
      copy[i] = !arr[i];
      return copy;
    });

    const descending = this.arrowSort()[i];
    let sort: VibrationsChart[] = [];

    if (propriete.nom === 'fileName') {
      sort = [...this.vibrationsChart()].sort((a, b) =>
        descending ? b.header.fileName.localeCompare(a.header.fileName)
                   : a.header.fileName.localeCompare(b.header.fileName));
    } else if (propriete.nom === 'serialNumber') {
      sort = [...this.vibrationsChart()].sort((a, b) =>
        descending ? b.header.equipementId.localeCompare(a.header.equipementId)
                   : a.header.equipementId.localeCompare(b.header.equipementId));
    } else if (propriete.nom === 'dateTime') {
      sort = [...this.vibrationsChart()].sort((a, b) =>
        descending ? new Date(a.header.timestamp).getTime() - new Date(b.header.timestamp).getTime()
                   : new Date(b.header.timestamp).getTime() - new Date(a.header.timestamp).getTime());
    }
    this.vibrationsChart.set(sort);
  }

  protected getControlPointName(controlPointId: number){
   let controlPoint =  this.controlPoints.filter(c => c.controlPointId === controlPointId)[0];
   if(controlPoint !== undefined) return controlPoint.name;
   else return '';
  }

  private diff(): boolean {
    return false;
  }

  private isFileAllowed(fileName: string) {
    let isFileAllowed = false;
    const allowedFiles = ['.csv', '.sis', ''];
    const regex = /(?:\.([^.]+))?$/;
    const extension = regex.exec(fileName);
    // const extension = fileName.split('.').pop();
    if (undefined !== extension && null !== extension) {
      for (const ext of allowedFiles) {
        if (ext === extension[0]) {
          isFileAllowed = true;
        }
      }
    }
    return isFileAllowed;
  }

  protected findMaxAbsValue(min: number, max: number) {
    return Math.abs(max) > Math.abs(min) ? max : Math.abs(min);
  }

  private checkChannelData(data: VibrationsChartChannel): boolean {
    let dataNullNumber = 0;
    data.value.forEach((v, i, a) => {
      if (v === 0) {
        dataNullNumber++;
      }
    });
    return dataNullNumber === data.value.length;
  }

  protected changeRemoteOrLocal(event: Event) {
    this.activeControlPointFilter.set(null);
    this.isRemoteOrLocal.update(v => !v);
    this.vibrationsNewModelSelected.set(undefined);
    this.indexSelected.set(undefined);
    if (event.target && (event.target as HTMLInputElement).checked) {
      this.vibrationsChart.set(this.vibrationsChartLocal());
    } else {
      this.vibrationsChart.set(this.vibrationsChartRemote());
    }
  }
  
  protected deleteFromTir() {
    this.fonctionsService.loading_screen(true);
    const vib = new VibrationsSave();
    const selected = this.vibrationsNewModelSelected();
    vib.id               = selected.id;
    vib.fileName         = selected.header.fileName;
    vib.siteId           = selected.header.siteId;
    vib.tirId            = 0;
    vib.controlPointId   = this.activeControlPoint().controlPointId;
    vib.idVibrationMaria = selected.idVibrationMaria;
    const arrayToSend = [vib];
    this.http.put('VibrationsMongo/' + this.siteId + '/DeafektingVibrationsFromTir', arrayToSend).subscribe((result) => {
      this.bsModalService.setDismissReason('vibDeleted');
      this.bsModalRef.hide();
      this.showToastAndCloseLoadingsScreen(true);
    }, (error: HttpErrorResponse) => {
      if (error.status === 401 || error.status === 403) {
        console.log(error.error);
      }
      this.bsModalRef.hide();
      this.showToastAndCloseLoadingsScreen(false);
    });
  }

  protected deleteOldVibrationFromTir() {
    this.fonctionsService.loading_screen(true);
    this.http.delete('Vibrations/' + this.vibrationOldModel.tirId + '/DeleteOldVibrationFromTir/' +  this.vibrationOldModel.id).subscribe((result:number) => {
      if(result > 0){
        this.bsModalService.setDismissReason('vibDeleted');
        this.bsModalRef.hide();
        this.showToastAndCloseLoadingsScreen(true);
      }else{
        this.bsModalRef.hide();
        this.showToastAndCloseLoadingsScreen(false);
      }
    }, (error: HttpErrorResponse) => {
      if(error.status === 401 || error.status === 403){
    console.log(error.error);
      }
      this.bsModalRef.hide();
      this.showToastAndCloseLoadingsScreen(false);
    });
  }

  protected controlPointFilterChange() {
    if (!this.isRemoteOrLocal()) {
      if (this.activeControlPointFilter() === null) {
        this.vibrationsChart.set(this.vibrationsChartRemote());
      } else {
        this.vibrationsChart.set(this.vibrationsChartRemote().filter(v => v.header.controlPointId === this.activeControlPointFilter().controlPointId));
      }
    } else if (this.isRemoteOrLocal()) {
      if (this.activeControlPointFilter() === null) {
        this.vibrationsChart.set(this.vibrationsChartLocal());
      } else {
        this.vibrationsChart.set(this.vibrationsChartLocal().filter(v => v.header.controlPointId === this.activeControlPointFilter().controlPointId));
      }
    }
  }

  protected deleteVibrationRemote(id: string) {
    if (this.estModif()) return;
    if (!this.isRemoteOrLocal()) {
      this.fonctionsService.loading_screen(true);
      this.http.delete('VibrationsMongo/' + this.utilService.currentSite().siteId + '/DeleteVibrationRemote/?id=' + id).subscribe((result: boolean) => {
        if (result) {
          this.vibrationsNewModelSelected.set(undefined);
          this.activeControlPoint.set(undefined);
          this.vibrationsChartRemote.update(arr => arr.filter(v => v.id !== id));
          this.vibrationsChart.set(this.vibrationsChartRemote());
          this.showToastAndCloseLoadingsScreen(true);
        } else {
          this.showToastAndCloseLoadingsScreen(false);
        }
      }, (error: HttpErrorResponse) => {
        if (error.status === 401 || error.status === 403) {
          console.log(error.error);
        }
        this.showToastAndCloseLoadingsScreen(false);
      });
    } else {
      this.vibrationsNewModelSelected.set(undefined);
      this.activeControlPoint.set(undefined);
      this.vibrationsChartLocal.update(arr => arr.filter(v => v.id !== id));
      this.vibrationsChart.set(this.vibrationsChartLocal());
    }
  }

  protected showModalCancel() {
    this.bsModalService.setDismissReason(this.fileTempSended());
    this.bsModalRef.hide();
  }

private showToastAndCloseLoadingsScreen(result:boolean){
  this.fonctionsService.launch_toast(result);
  this.fonctionsService.loading_screen(false);
}




}
